import { render } from "./footerpage.vue?vue&type=template&id=61e91662&scoped=true"
import script from "./footerpage.vue?vue&type=script&lang=js"
export * from "./footerpage.vue?vue&type=script&lang=js"

import "./footerpage.vue?vue&type=style&index=0&id=61e91662&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e91662"]])

export default __exports__